module.exports = __webpack_public_path__ + "3f16e137/img/link-icon.fa09ed66.svg";